<div class="product-grade" *ngIf="options">
    <div class="product-grade__inner product-grade__inner--hero">
        <h4 class="product-grade__title">
            {{ options.title }}
            <span class="product-grade__subtitle">
                {{ options.subtitle }}
            </span>
        </h4>
        <ng-container *ngIf="options.number">
            <div class="product-grade__reviews">
                <p>
                    <a
                        [routerLink]="['/', options.reviewUrl, 'reviews']"
                        rel="nofollow"
                        title="uit {{ productGrade?.totaal }} beoordelingen"
                    >
                        uit {{ productGrade?.totaal }} beoordelingen
                    </a>
                </p>
            </div>
        </ng-container>
        <div class="product-grade__grade">
            <a
                [routerLink]="['/', options.reviewUrl, 'reviews']"
                rel="nofollow"
                class="product-grade__grade-link"
                title="uit {{ productGrade?.totaal }} beoordelingen"
            >
                <span
                    *ngIf="productGrade?.gemiddelde_score.tiental && productGrade?.gemiddelde_score.decimaal"
                    class="product-grade__grade-inner"
                >
                    <span class="product-grade__first-char">{{ productGrade?.gemiddelde_score.tiental }}</span>
                    <span class="product-grade__second-char">.{{ productGrade?.gemiddelde_score.decimaal }}</span>
                </span>
            </a>
        </div>
    </div>
</div>
